

import RefreshNotifications from './RefreshNotifications';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Spinner, Button, Badge, Table, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import validator from 'validator';
import ShowDaneStatus from './ShowDaneStatus';
import ShowDaneWeekendDay from './ShowDaneWeekendDay';
import { useContext } from 'react';

import { AppContext } from './context/AppContext';
import { jwtDecode } from "jwt-decode";
import { Link } from 'react-router-dom';

const DaneDatesLising = () => {

  const { setToken, token, setUser, currentUser, setLoadingApp } = useContext(AppContext);

  const[data, setdata] = useState(null); 
  const[error, setError] = useState(null); 
  const dataFetchedRef = useRef(false);
  const [inProgress, setInProgress] = useState(false);

  const[refresh, setRefresh] = useState(false); 
  const[refreshSignalR, setRefreshSignalR] = useState(0); 
  
  const [selectedItemObj, setSelectedItemObj] = useState(null);

  const [show, setShow] = useState(false);
  const [showadmin, setShowadmin] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const [nextprogress, setnextprogress] = useState(false);
  const [prevprogress, setprevprogress] = useState(false);
  const [currentprogress, setcurrentprogress] = useState(false);

  const [InvalidPhone, setInvalidPhone] = useState(false);
  const [InvalidPhoneAlt, setInvalidPhoneAlt] = useState(false);

  const [monthno, setmonthno] = useState(0);

  
  const [phone, setPhone] = useState("");
  const [phonealt, setPhonealt] = useState("");

  const handleClose = () => setShow(false);
  const handleCloseadmin = () => setShowadmin(false);
  const handleCloseLogin = () => setShowLogin(false);


  const [showGoogleForm, setShowGoogleForm] = useState(false);
const googleFormIframeRef = useRef();

const handleShowGoogleForm = () => setShowGoogleForm(true);
const handleCloseGoogleForm = () => setShowGoogleForm(false);

  function handleShow(obj, DaneTime){

    console.log(obj);
    let obj2 = {...obj, "danetime":DaneTime}
    
    setSelectedItemObj(obj2);

    setInvalidPhoneAlt(false)
    setInvalidPhone(false)
    setShow(true)    
      
}

function handleShowAdmin(obj){
    
    setSelectedItemObj(obj);

    const selFormModal = {...formModal,
        notification : obj.notificationText,
        badgetext : obj.badgeText,
        heelname : obj.heelDaneDoneteeName,
        heelmobile : obj.heelDaneDoneteePhone,
        heelmobilealt : obj.heelDaneDoneteePhoneAlt,
        dahawalaname : obj.dahawalDaneDoneteeName,
        dahawalamobile : obj.dahawalDaneDoneteePhone,
        dahawalamobilealt : obj.dahawalDaneDoneteePhoneAlt,
        
    }

    setFormModal(selFormModal);

    setShowadmin(true)    
      
}

const formDefault = {};

const [formModal, setFormModal] = useState(formDefault);
const [validated, setValidated] = useState(false);
const [validatedalt, setValidatedalt] = useState(false);

const modalForm = useRef(null);
const modalFormLogin = useRef(null);
const modalFormadmin = useRef(null);


const handleSubmitLogin = (event) => {


  const form = event.currentTarget;
  if (form.checkValidity() === false) {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    return;
  }


  setValidated(false);
  setInProgress(true);
        setError(null);

  event.preventDefault();

  let sPasscode = modalFormLogin.current.querySelector('#passcode').value;
  const frmFormData = new FormData();

    frmFormData.append("password", sPasscode)             
    const sURL = process.env.REACT_APP_API_BASE_URL + 'Token';

    
    const headers = {
      'Content-Type': 'application/json',               
    };

    axios.post(sURL,frmFormData,{headers})      
    .then((Response)=>{

      //console.log(Response)
      let sUserData = Response.data;
      
      localStorage.clear();
      localStorage.setItem(process.env.REACT_APP_API_AUTH_TOKEN,Response.data);  

      const token = Response.data;
      const decoded = jwtDecode(token);

      setToken(token);
      setUser(decoded);    

      localStorage.setItem("UserAuth",decoded.accesstype);  

      setRefresh(!refresh)
      setShowLogin(false);
                  
    }).catch(error => {
        setError(error);     
        //console.log({error})
    });


}


const refreshClick = () => {
  dataFetchedRef.current = false;
  setRefresh(!refresh);  
}

// const prevClick = () => { 
//   setprevprogress(true);  
//   setmonthno(pre=>(pre-1));  
//   fetchDaneDates();
// }

// const nextClick = () => { 
//   setnextprogress(true);      
//   setmonthno(pre=>(pre + 1 ));  
//   fetchDaneDates();
// }

// const setCurrMonth = () =>{
//   setcurrentprogress(true);      
//   setmonthno(0); 
//   fetchDaneDates();
// }

const prevClick = () => {
    setprevprogress(true);
    setmonthno(prev => prev - 1);
};
const nextClick = () => {
    setnextprogress(true);
    setmonthno(prev => prev + 1);
};
const setCurrMonth = () => {
    setcurrentprogress(true);
    setmonthno(0);
};


const isPreviousDate = (dateString) => {
  const currentDate = new Date();
  const inputDate = new Date(dateString);

  inputDate.setDate(inputDate.getDate() + 1)
  return inputDate < currentDate;

};


const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(false);        

    event.preventDefault();

    let sName = modalForm.current.querySelector('#name').value;
    let sMobile = modalForm.current.querySelector('#mobile').value;
    let sMobilealt = modalForm.current.querySelector('#mobilealt').value;

      const phoneValid = validator.isMobilePhone(sMobile);
      if (!phoneValid || sMobile.length < 11){
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        setInvalidPhone(true)
        return;
      }
  
      if(sMobilealt !=="")
      {
        const phoneValidalt = validator.isMobilePhone(sMobilealt);        
        if (!phoneValidalt || sMobilealt.length < 11){
          event.preventDefault();
          event.stopPropagation();
          setValidatedalt(true);
          setInvalidPhoneAlt(true)
          return;
        }
    }
   

    const frmFormData = new FormData();

      frmFormData.append("date", selectedItemObj.date)     
      frmFormData.append("Id", selectedItemObj.id)     
      
      if(selectedItemObj.danetime==="heel"){

        frmFormData.append("HeelDaneTaken", true);     
        frmFormData.append("heelDaneDoneteeName", sName);     
        frmFormData.append("heelDaneDoneteePhone", sMobile);     
        frmFormData.append("heelDaneDoneteePhoneAlt", sMobilealt);     

        frmFormData.append("dahawalDaneTaken", selectedItemObj.dahawalDaneTaken??false);     
        frmFormData.append("dahawalDaneDoneteeName", selectedItemObj.dahawalDaneDoneteeName);     
        frmFormData.append("dahawalDaneDoneteePhone", selectedItemObj.dahawalDaneDoneteePhone); 
        frmFormData.append("dahawalDaneDoneteePhoneAlt", selectedItemObj.dahawalDaneDoneteePhoneAlt); 

      }else{
        
        frmFormData.append("HeelDaneTaken", selectedItemObj.heelDaneTaken??false);     
        frmFormData.append("heelDaneDoneteeName", selectedItemObj.heelDaneDoneteeName);     
        frmFormData.append("heelDaneDoneteePhone", selectedItemObj.heelDaneDoneteePhone);     
        frmFormData.append("heelDaneDoneteePhoneAlt", selectedItemObj.heelDaneDoneteePhoneAlt);     

        frmFormData.append("dahawalDaneTaken", true);     
        frmFormData.append("dahawalDaneDoneteeName", sName);     
        frmFormData.append("dahawalDaneDoneteePhone", sMobile); 
        frmFormData.append("dahawalDaneDoneteePhoneAlt", sMobilealt); 

      }


      const sURL = process.env.REACT_APP_API_BASE_URL + 'DaneDates';

      
      const headers = {
        'Content-Type': 'application/json',  
        'Authorization': 'Bearer '+ token ,      
      };

      axios.post(sURL,frmFormData,{headers})      
      .then((Response)=>{

          setPhone("");
          setPhonealt("");

          setRefresh(!refresh)

          setShow(false);
          

      }).catch(error => {
          setError(error);     
          //console.log({error})
      });
  
  };


  const refreshClickAlt = () => {
    
    dataFetchedRef.current = false;
    setRefreshSignalR(pre=>pre + 1) ;

  }
  

  const handleSubmitAdmin = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(false);

    event.preventDefault();

    let sHeelName = modalFormadmin.current.querySelector('#heelname').value;
    let sHeelMobile = modalFormadmin.current.querySelector('#heelmobile').value;
    let sHeelMobilealt = modalFormadmin.current.querySelector('#heelmobilealt').value;

    let sHeelTaken = false;
    if(sHeelName !== "") sHeelTaken = true;

    let sdahawalaName = modalFormadmin.current.querySelector('#dahawalaname').value;
    let sdahawalaMobile = modalFormadmin.current.querySelector('#dahawalamobile').value;
    let sdahawalaMobilealt = modalFormadmin.current.querySelector('#dahawalamobilealt').value;

    let sdahawalaTaken = false;
    if(sdahawalaName !== "") sdahawalaTaken = true;

    let sNotification = modalFormadmin.current.querySelector('#notification').value;
    let sBadgetext = modalFormadmin.current.querySelector('#badgetext').value;

    const frmFormData = new FormData();

      frmFormData.append("date", selectedItemObj.date)     
      frmFormData.append("Id", selectedItemObj.id)     
      
      frmFormData.append("HeelDaneTaken", sHeelTaken);     
      frmFormData.append("heelDaneDoneteeName", sHeelName);     
      frmFormData.append("heelDaneDoneteePhone", sHeelMobile);     
      frmFormData.append("heelDaneDoneteePhoneAlt", sHeelMobilealt);     

      frmFormData.append("dahawalDaneTaken", sdahawalaTaken);     
      frmFormData.append("dahawalDaneDoneteeName", sdahawalaName);     
      frmFormData.append("dahawalDaneDoneteePhone", sdahawalaMobile); 
      frmFormData.append("dahawalDaneDoneteePhoneAlt", sdahawalaMobilealt); 
      
      frmFormData.append("notificationText", sNotification); 
      frmFormData.append("badgeText", sBadgetext); 

      


      const sURL = process.env.REACT_APP_API_BASE_URL + 'DaneDates';

      
      const headers = {
        'Content-Type': 'application/json',    
        'Authorization': 'Bearer '+ token ,    
      };

  
      axios.post(sURL,frmFormData,{headers})      
      .then((Response)=>{

          //setUser("admin");
          setPhone("");
          setPhonealt("");
          setRefresh(!refresh)
          setShowadmin(false);

      }).catch(error => {
          setError(error);     
          console.log({error})
      });
      
  };


  useEffect(()=>{


      fetchDaneDates();
               

    },[monthno,refresh,refreshSignalR])
  

    const fetchDaneDates = () => {

      //setdata(null); // Clear data right away, before async call

  let baseURL = process.env.REACT_APP_API_BASE_URL + "DaneDates/" + monthno;
  if (currentUser && currentUser.accesstype === "admin") {
    baseURL =
      process.env.REACT_APP_API_BASE_URL + "DaneDates/getfulldata/" + monthno;
  }

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };

  axios.get(baseURL, { headers })
    .then((response) => {
      const currData = response.data;
      setdata(currData); // update list/table first
           
    })
    .catch((error) => {
      if (error.message === "Request failed with status code 401") {
        localStorage.clear();
        setUser("");
        setToken("");
      } else {
        setError(error);
      }
    })
    .finally(() => {
      // Always turn off all progress indicators at the end
      setprevprogress(false);
      setnextprogress(false);
      setcurrentprogress(false);
      
    });
};




function retrunMonthName(sdate){

    const monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                        ];
    const d = new Date(sdate);
    return monthNames[d.getMonth()] + ' ' + d.getFullYear();
}

function getMonthLabel(monthOffset) {
  const now = new Date();
  const d = new Date(now.getFullYear(), now.getMonth() + monthOffset, 1);
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  return monthNames[d.getMonth()] + " " + d.getFullYear();
}

const adminClick = () => {

  setShowLogin(true);

}
const adminlogoutClick = () => {
  localStorage.clear();  
  setUser("");
}

  const googleFormUrl =
    currentUser && currentUser.TenantName === "Wales"
      ? "https://forms.gle/yadiJfdj6MEa4dgn7?embedded=true"
      : "https://forms.gle/hoWZTRy5krSFQn858?embedded=true";


    if (error) 
    { 
        return "Error:" + error.message;
    }

    if(!data) return (
        <Spinner animation="border" variant="primary" />
        );

  //alert (googleFormUrl);
  
  return (
    <>
   
      
    <RefreshNotifications setRefresh2={refreshClickAlt} />
    
<Container fluid="md" style={{marginTop:'5px'}}>
      <Row>
        <Col className='col-2'> 
           <img src="/mahamevnawalogo.png" alt="mahamevnawa London" height={"65px"} style={{marginBottom:"3px"}} />        
        </Col>
        <Col className='col-10'>
          <span> <b>නමෝ බුද්ධාය</b> - <b>{currentUser.TenantName}</b> අසපුව - <b>දානය</b></span>
          <h2>        
          <Button size='sm' style={{color:'black',fontSize:"12px" }} variant="outline-warning" disabled={monthno===0} onClick={prevClick} >             
             {prevprogress && <><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></>}
            {!prevprogress && <>&lt; Prev Month  </>}            
          </Button>&nbsp;

          {monthno > 1 && !currentprogress && <><Button variant="secondary" size='sm' onClick={setCurrMonth}>This Month</Button>&nbsp;</>} 

          {!currentprogress && 
          <Badge style={{backgroundColor:'orange', color:'black', fontSize:"18px" }} bg="xsecondary">         
            {getMonthLabel(monthno)}
          </Badge>
          }
          {currentprogress && <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>} 
          &nbsp;       
          <Button size='sm' style={{color:'black',fontSize:"12px" }} variant="outline-warning" disabled={(currentUser.accesstype !== "admin" && monthno > 1) || nextprogress  } onClick={nextClick} >
            {nextprogress && <><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></>}
            {!nextprogress && <>Next Month&gt; </>}
          </Button> &nbsp;&nbsp;
         
<Button variant="warning" size="sm" style={{marginLeft: "12px"}} onClick={handleShowGoogleForm}>
    Arama Pujawa
  </Button>

          {/* {refreshSignalR} */}
          

          </h2>        
          {/* &nbsp;&nbsp; &nbsp;&nbsp;
          <h6>
          {currentUser.accesstype ==="superadmin" && <Link to="/orgsetup">Organization Setup</Link>}
          {(currentUser.accesstype ==="admin" || currentUser.accesstype ==="superadmin") && <Link to="/donors">Donor Listing</Link>}
          </h6> */}
         
          
       </Col>
       {(currentUser.accesstype ==="admin" || currentUser.accesstype ==="superadmin") &&
       <>
       {/* <Col className='col-6 text-end'>
            <Button variant='primary'><Link to="/donors">Donor Listing</Link></Button>
          </Col> */}
       {/* <Col className='col-2'>        
          <>Login as <b>{currentUser.name.toString()}</b> &nbsp; <Button variant="outline-warning" onClick={adminlogoutClick}>Log Out</Button></>         
       </Col></> */}
        <hr></hr>
         <Col className='col-6' >        
                  <>Login as <b>{currentUser.name.toString()}</b> &nbsp; <Button size='sm' variant="outline-warning" onClick={adminlogoutClick}>Log Out</Button></>         
               </Col>
             
               <Col className='col-3' > 
                <Link to="/"><Button variant="outline-success" size='sm' >Back to Main Menu</Button></Link>  
               </Col> 
               <hr></hr>              
               </>
               
              }

      </Row>     
        
      <Row>
        <Col>    
        
          <Table bordered hover responsive="sm" size='sm' variant="light">
            <thead>
              <tr key="header00">
                <th key="header0" style={{backgroundColor:'orange', fontSize:"12px", fontWeight:"bold"}}>දිනය</th>
                <th key="header1" style={{backgroundColor:'orange',fontSize:"12px"}}>දවස</th>
                <th key="header2" style={{backgroundColor:'orange'}}></th>
                <th key="header3" style={{backgroundColor:'orange', fontSize:"12px", fontWeight:"bold"}}>උදෑසන දනය</th>
                <th key="header4" style={{backgroundColor:'orange', fontSize:"12px", fontWeight:"bold"}}>දහවල්  දනය</th>
                {currentUser.accesstype === "admin" && <th key="header5" style={{backgroundColor:'orange'}}></th>}
              </tr>
            </thead>
            <tbody>

              {(prevprogress || nextprogress || currentprogress) ? (
            <div style={{textAlign: 'center', margin: '30px'}}>
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (  data && data.map((item)=>{   


                  let bgColour = ""
                  if(item.datetype === "weekend" && item.day==="Saturday") bgColour = "#fff3cc";
                  if(item.datetype === "weekend" && item.day==="Sunday") bgColour = "#fff3cc";
                  if(item.badgeText !== "") bgColour = "Gold";

              
                  return(
                      <>              
                      <tr key={item.date} style={{fontSize:"15px"}} >
                        <td valign='middle' style={{backgroundColor:bgColour}} width={"10%"} ><strong>{item.date}</strong>
                        </td>
                        <td valign='middle' width={"6%"} style={{backgroundColor:bgColour,textAlign:"left",fontSize:"15px"}}>
                        <ShowDaneWeekendDay sdaytype={item.datetype} sday={item.day} /> 
                        </td>
                        <td width={"16%"} style={{backgroundColor:bgColour, textAlign:"left", padding:"1px"}}>            
                        {item.badgeText !== "" && <span> <Badge bg="warning" style={{color:"black", fontSize:"15px"}}>{item.badgeText}</Badge></span>}                        
                        {item.notificationText !== "" && <span style={{color:"black", fontSize:"15px"}}>&nbsp;{item.notificationText}</span>}
                        </td>
                        

                        <td valign='middle' style={{backgroundColor:bgColour}} width={currentUser.accesstype !== "admin" && "6%"} >
                            <Container fluid>
                                <Row>
                                {currentUser.accesstype !== "admin" && <Col><ShowDaneStatus dataItemstatus={String(item.heelDaneTaken)} handleShow={handleShow} itemObj={item} DaneTime = "heel"/></Col>}
                            {currentUser.accesstype === "admin" && String(item.heelDaneTaken)==="true" &&                     
                                  <>
                                  <Col> <div style={{float:'left', textAlign:'left'}} ><b>Name</b> : {item.heelDaneDoneteeName}<br></br> <b>Phone</b> : {item.heelDaneDoneteePhone} {item.heelDaneDoneteePhoneAlt !=="" && ", "+ item.heelDaneDoneteePhoneAlt }</div></Col>                                  
                                  </>      
                            }
                            {currentUser.accesstype === "admin" && !isPreviousDate(item.date) && String(item.heelDaneTaken)!=="true" && <Button size='sm' disabled={isPreviousDate(item.date)} variant='outline-success' onClick={()=>{handleShow(item,"heel")}}>+ Add</Button>}
                            </Row>                   
                            </Container>            
                        </td>
                        
                        <td valign='middle' style={{backgroundColor:bgColour}} width={currentUser.accesstype !== "admin" &&"6%"} >                
                            <Container fluid>
                                <Row>
                                {currentUser.accesstype !== "admin" && <Col><ShowDaneStatus dataItemstatus={String(item.dahawalDaneTaken)} handleShow={handleShow} itemObj={item} DaneTime = "dahawal" /></Col>}
                            {currentUser.accesstype === "admin" && String(item.dahawalDaneTaken)==="true" &&                    
                                  <>
                                  <Col> <div style={{float:'left', textAlign:'left'}} ><b>Name</b> : {item.dahawalDaneDoneteeName}<br></br> <b>Phone</b> : {item.dahawalDaneDoneteePhone} {item.dahawalDaneDoneteePhoneAlt !=="" && ", "+ item.dahawalDaneDoneteePhoneAlt }</div></Col>                                    
                                  </>      
                            }

                            {currentUser.accesstype === "admin" && !isPreviousDate(item.date) && String(item.dahawalDaneTaken)!=="true" && <Button disabled={isPreviousDate(item.date)} size='sm' variant='outline-success' onClick={()=>{handleShow(item,"dahawal")}}>+ Add</Button>}
                            </Row>                   
                            </Container>                 
                        </td>
                        
                        {currentUser.accesstype === "admin" && !isPreviousDate(item.date) && <td style={{backgroundColor:bgColour}}><Button disabled={isPreviousDate(item.date)} variant='outline-success' size='sm' onClick={()=>{handleShowAdmin(item)} }>Edit</Button> </td>}           

                      </tr>                
                </>                
                )         
              }))}
              
            </tbody>
        </Table>
             
      </Col>
      </Row>
      <Row>
       <Col>    
       {/* <h3>{refreshSignalR}</h3> */}
       <h2>
        <Button size='sm' style={{color:'black',fontSize:"12px" }} variant="outline-warning" disabled={monthno===0} onClick={prevClick} > &lt; Prev Month </Button>&nbsp;
        {monthno > 1 && <><Button variant="secondary" size='sm' onClick={setCurrMonth}>This Month</Button>&nbsp;</>} 
        <Badge style={{backgroundColor:'orange', color:'black', fontSize:"18px" }} bg="xsecondary">         
          {getMonthLabel(monthno)} 
        </Badge>&nbsp;        
        <Button size='sm' style={{color:'black',fontSize:"12px" }} variant="outline-warning" disabled={currentUser.accesstype !== "admin" && monthno > 1 } onClick={nextClick} >Next Month&gt; </Button> &nbsp;&nbsp;
        {currentUser.accesstype !== "admin" && <><Button size='sm' variant="outline-success" onClick={adminClick}>Admin</Button> <Button size='sm' variant="outline-success" onClick={refreshClick} >Refresh</Button></> } 
        </h2>   
        
        </Col>
      </Row>  

      <Row>
        <Col>       
       <hr></hr>
       {/* <h6><b>London Asapuwa</b> 56, Vernon Dr, Stanmore, HA7 2BT  </h6> */}
       <h6><b>{currentUser.TenantName} අසපුව</b> {currentUser.TenantAddress}  </h6>
       <hr></hr>
        </Col>
      </Row>  
     
    </Container>

{selectedItemObj && 
    <Modal show={show} onHide={handleClose} backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered> 
    <Form ref={modalForm} noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedItemObj.date} {selectedItemObj.day} (<span className='text-capitalize'>{selectedItemObj.danetime}</span> Dane)</Modal.Title>
        </Modal.Header>
       
        <Modal.Body>
            
                <Form.Group className="mb-3" >
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" autoComplete="off" placeholder="" required id="name" />
                    <Form.Control.Feedback type="invalid">
                        Please enter your name.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" >
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control type="text" placeholder="" autoComplete="off" maxLength="11" required id="mobile" isInvalid={!validator.isMobilePhone(phone) && validated} value={phone} onChange={e=>{setPhone(e.target.value)}} />
                    {!InvalidPhone && 
                    <Form.Control.Feedback type="invalid">
                        Please enter your mobile phone number.
                    </Form.Control.Feedback>
                    }
                    {InvalidPhone && <span style={{color:"red"}}>Invalid Phone Number</span>}
                </Form.Group>     
                <Form.Group className="mb-3" >
                    <Form.Label>Alt Phone Number</Form.Label>
                    <Form.Control type="text" placeholder="" autoComplete="off" maxLength="11" id="mobilealt" isInvalid={!validator.isMobilePhone(phonealt) && validatedalt} value={phonealt} onChange={e=>{setPhonealt(e.target.value)}} />
                    {!InvalidPhoneAlt && 
                    <Form.Control.Feedback type="invalid">
                        Invalid phone number.
                    </Form.Control.Feedback>
                    }
                    {InvalidPhoneAlt && <span style={{color:"red"}}>Invalid Phone Number</span>}
                </Form.Group>     
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success" type='submit'>
            reserve
          </Button>
         
        </Modal.Footer> 
    </Form>
    </Modal>
}

{selectedItemObj && 
    <Modal show={showadmin} onHide={handleCloseadmin} backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered size='md'> 
    <Form ref={modalFormadmin} onSubmit={handleSubmitAdmin}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedItemObj.date} {selectedItemObj.day} Dane</Modal.Title>
        </Modal.Header>
       
        <Modal.Body>
                
                <Form.Group className="mb-3" >
                    <Form.Label>Notification Text</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.notification} id="notification" />                   
                </Form.Group>

                <Form.Group className="mb-3" >
                    <Form.Label>Badge Text</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.badgetext} id="badgetext" />                   
                </Form.Group>


                <h4>Heel Dane (උදෑසන දනය)</h4>
                <Form.Group className="mb-3" >
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="" autoComplete="off" defaultValue={formModal.heelname} id="heelname" />                
                </Form.Group>
                <Form.Group className="mb-3" >
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control type="phone" placeholder="" autoComplete="off" defaultValue={formModal.heelmobile} id="heelmobile"/>                    
                </Form.Group>     
                <Form.Group className="mb-3" >
                    <Form.Label>Alt Phone Number</Form.Label>
                    <Form.Control type="phone" placeholder="" autoComplete="off" defaultValue={formModal.heelmobilealt} id="heelmobilealt"/>                    
                </Form.Group>     
                <br></br>       
                <h4>Dahawala Dane (දහවල් දනය)</h4>
                <Form.Group className="mb-3" >
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="" autoComplete="off" defaultValue={formModal.dahawalaname} id="dahawalaname" />                    
                </Form.Group>
                <Form.Group className="mb-3" >
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control type="phone" placeholder="" autoComplete="off" defaultValue={formModal.dahawalamobile} id="dahawalamobile"/>                    
                </Form.Group>                                            
                <Form.Group className="mb-3" >
                    <Form.Label>Alt Phone Number</Form.Label>
                    <Form.Control type="phone" placeholder="" autoComplete="off" defaultValue={formModal.dahawalamobilealt} id="dahawalamobilealt"/>                    
                </Form.Group>                                            
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseadmin}>
            Close
          </Button>
          <Button variant="success" type='submit'>
            Save
          </Button>
         
        </Modal.Footer> 
    </Form>
    </Modal>
}


{
    <Modal show={showLogin} onHide={handleCloseLogin} backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered> 
    <Form ref={modalFormLogin} noValidate validated={validated} onSubmit={handleSubmitLogin}>
        <Modal.Header closeButton>
          <Modal.Title>Administrator Login</Modal.Title>
        </Modal.Header>
       
        <Modal.Body>
            
                <Form.Group className="mb-3" >
                    <Form.Label>Administrator Passcode</Form.Label>
                    <Form.Control type="text" placeholder="" required id="passcode" />
                    <Form.Control.Feedback type="invalid">
                        Please enter admin passcode.
                    </Form.Control.Feedback>
                    {error && error.message.indexOf("status code 400") && <><span style={{color:"red",}}>Invalid Organization PassCode</span></>}
                </Form.Group>                
        </Modal.Body>
        <Modal.Footer>
        {!inProgress && 
      <>
      <Button variant="secondary" onClick={handleCloseLogin}>
        Close
      </Button>
      <Button variant="success" type='submit' >
        Login
      </Button>     
      </>
      }
      {inProgress && <span><h6><Spinner animation="grow" /> Please Wait...</h6></span> }
         
        </Modal.Footer> 
    </Form>
    </Modal>
}


<Modal show={showGoogleForm} onHide={handleCloseGoogleForm} size="lg" centered backdrop="static">
  <Modal.Header closeButton>
    <Modal.Title>Arama Pujawa</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{height: "500px", padding: 0}}>
    <iframe
      ref={googleFormIframeRef}
      //src="https://docs.google.com/forms/d/e/your-google-form-id/viewform?embedded=true"
      src={googleFormUrl}//"https://forms.gle/hoWZTRy5krSFQn858?embedded=true"
      title="Google Form"
      width="100%"
      height="600px"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      style={{border: 0}}
      allowFullScreen
    />
  </Modal.Body>
</Modal>


    </>

  )
}

export default DaneDatesLising